export function goPageByUrl(urlPage){
    const urlGo = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + urlPage;
    window.location.href = urlGo;
}
export function getFullUrl(urlParams){
    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + urlParams;
}
